/* Human labels for the permission actions.
 *
 * The matrix used to print the backend's own identifiers — `view`,
 * `view_data`, `run_chat`, `run_ai_analysis`, `send_report`, `upload`,
 * `download`, `delete` — at the operator deciding what a person can see. They are
 * column names, not words.
 *
 * A value outside this list comes back RAW, wrapped in a marker the
 * caller renders as a defect. It is never prettified into something
 * plausible: this screen decides access, and an invented label that
 * reads well is exactly how somebody grants the wrong thing.
 */

/** Just the key — none of these labels interpolate. */
export type PermissionLabelT = (key: string) => string;

const KNOWN = [
  "view",
  "view_data",
  "run_chat",
  "run_ai_analysis",
  "send_report",
  "schedule_send",
  "upload",
  "download",
  "delete",
] as const;

export function isKnownPermissionAction(action: string): boolean {
  return (KNOWN as readonly string[]).includes(action);
}

/** The label, or the raw identifier when there is no translation yet. */
export function permissionActionLabel(
  t: PermissionLabelT,
  action: string,
): string {
  return isKnownPermissionAction(action)
    ? t(`adminUsers.perms.action.${action}`)
    : action;
}
